import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const EmployeeKpiSettingsList = Loadable(
  lazy(() => import("./EmployeeKpiSettingsList")),
);
const EmployeeKpiSettingsForm = Loadable(
  lazy(() => import("./EmployeeKpiSettingsForm")),
);

const employeeKpiSettingsRoutes = [
  {
    path: "/EmployeeKpiSettings/EmployeeKpiSettingsList",
    element: <EmployeeKpiSettingsList />,
    permission: PERMISSIONS.EmployeeKpiSettings.Menu,
  },
  {
    path: "/EmployeeKpiSettings/EmployeeKpiSettingsForm",
    element: <EmployeeKpiSettingsForm />,
  },
  {
    path: "/EmployeeKpiSettings/EmployeeKpiSettingsForm/:employeeKpiSettingsId",
    element: <EmployeeKpiSettingsForm />,
  },
];

export default employeeKpiSettingsRoutes;
